import { STAGE_COLORS } from "../../constants/dealStages";

export default function StageBadge({ stage }) {
  return (
    <span
      className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
        STAGE_COLORS[stage] ?? "bg-[#3a3a3a] text-[#b4b4b4]"
      }`}
    >
      {stage}
    </span>
  );
}
